import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import {
  CTAWrapper,
  HeaderSection,
  HeaderShell,
  LogoContainer,
  BrandMark,
  DesktopNav,
  MobileAction,
  MobileNav,
  MobilePanel,
  MobileToggle,
  NavButton,
} from "./styles";

const Header = () => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const toggleMenu = () => {
    setOpen((current) => !current);
  };

  const scrollToSection = (id: string) => {
    const runScroll = () => {
      const element = document.getElementById(id) as HTMLDivElement | null;
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
        });
      }
    };

    if (location.pathname !== "/") {
      history.push("/");
      window.setTimeout(runScroll, 140);
    } else {
      runScroll();
    }

    setOpen(false);
  };

  const menuItems = [
    { label: "About", target: "about" },
    { label: "How it works", target: "how-it-works" },
    { label: "Features", target: "features" },
  ];

  const navigation = (
    <>
      {menuItems.map((item) => (
        <NavButton key={item.target} type="button" onClick={() => scrollToSection(item.target)}>
          {item.label}
        </NavButton>
      ))}
      <CTAWrapper>
        <Button onClick={() => scrollToSection("download")}>Download App</Button>
      </CTAWrapper>
    </>
  );

  return (
    <HeaderSection>
      <Container>
        <HeaderShell>
          <LogoContainer
            to="/"
            aria-label="You&Me home"
            onClick={() => {
              setOpen(false);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <BrandMark
              src="/img/new/logo.png"
              alt="You&Me Indian dating logo"
              width="120"
              height="120"
              loading="lazy"
              decoding="async"
            />
          </LogoContainer>
          <DesktopNav aria-label="Primary">
            {navigation}
          </DesktopNav>
          <MobileToggle
            type="button"
            onClick={toggleMenu}
            open={open}
            aria-expanded={open}
            aria-label={open ? "Close navigation" : "Open navigation"}
          >
            <span />
            <span />
            <span />
          </MobileToggle>
        </HeaderShell>
        <MobilePanel open={open}>
          <MobileNav aria-label="Mobile primary">
            {menuItems.map((item) => (
              <NavButton
                key={item.target}
                type="button"
                onClick={() => scrollToSection(item.target)}
              >
                {item.label}
              </NavButton>
            ))}
          </MobileNav>
          <MobileAction>
            <Button onClick={() => scrollToSection("download")}>Download App</Button>
          </MobileAction>
        </MobilePanel>
      </Container>
    </HeaderSection>
  );
};

export default Header;
